import { graphql } from '@/generated/gql';

export const INTAKE_REQUEST_DESCRIPTION = graphql(/* GraphQL */ `
  query IntakeRequestDescription($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        requestDescription {
          id
          text
          language
        }
        requirementsExtraction {
          id
          extractedData
          enhancedData
          processingStatus
        }
      }
    }
  }
`);
